import React, { useEffect, useState, useContext, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../Routes/AuthProvider";

const REACT_APP_API = process.env.REACT_APP_API_BASE_URL;

const Login = () => {
	const navigate = useNavigate();
	const { token, login } = useContext(AuthContext);

	// If already logged in → redirect
	useEffect(() => {
		if (token) {
			navigate("/flight");
		}
	}, [token]);

	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");
	const [errorEmail, setErrorEmail] = useState("");
	const [errorPassword, setErrorPassword] = useState("");
	const passwordRef = useRef(null);
	const emailRef = useRef(null);

	const handleLogin = async (e) => {
		e.preventDefault();
		setError("");
		setErrorEmail("");
		setErrorPassword("");


		const emailValue = email.trim();
		if (!emailValue) {
			setErrorEmail("Please enter Email ID.");
			emailRef.current?.focus();
			return;
		}
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (!emailRegex.test(emailValue)) {
			setErrorEmail("Please enter a valid Email ID.");
			emailRef.current?.focus();
			return;
		}

		if (!password.trim()) {
			setErrorPassword("Please enter Password.");
			passwordRef.current?.focus();
			return;
		}
		setLoading(true);
		try {
			const params = {
				userName: email,
				password: password,
				//role:role,
			};
			const res = await axios.post(`${REACT_APP_API}/api/Account/login`, params);
			console.log("res", res)
			if (res.status === 200) {
				// localStorage.setItem("token", res.data.token);
				// navigate("/flight");

				login(res.data.token, res.data.userName, res.data.companyId, res.data.name, res.data.roles);
				navigate("/flight"); // redirect to protected route
			}
		} catch (err) {
			setError("Invalid username or password");
		} finally {
			setLoading(false);
		}
	};


	return (
		<>
			<div id="kt_body" class="auth-bg">
				<div class="d-flex flex-column flex-root">
					<div class="d-flex flex-column flex-column-fluid flex-lg-row">

						<div class="d-flex flex-center w-lg-50 pt-15 pt-lg-0 px-10">

							<div class="d-flex flex-center flex-lg-start flex-column mobile-none">

								<a href="/" class="mb-7">
									<img src="/assets/images/logo.png" alt="img" className='logo_login' />
								</a>
								<h2 class="text-white fw-normal m-0">Travel Management System</h2>

							</div>
						</div>
						<div class="d-flex flex-column-fluid flex-lg-row-auto justify-content-center justify-content-lg-end p-12">

							<div class="bg-body d-flex flex-column align-items-stretch flex-center rounded-4 w-md-500px p-10">

								<div class="d-flex flex-center flex-column flex-column-fluid px-lg-0">

									{/* <form class="form w-100" novalidate="novalidate" id="kt_sign_in_form" data-kt-redirect-url="index.html" action="#"> */}
									<form class="form w-100" onSubmit={handleLogin}>

										<div class="text-center mb-15 mt-5">
											<img src="/assets/images/logo.png" alt="img" className='logo_login desk-none' />
											<h1 class="text-gray-900 fw-bolder mb-3 mobile-none">Sign In</h1>
										</div>
										{error && <p className="text-danger text-center">{error}</p>}
										<div class="fv-row mb-8">
											<input
											ref={emailRef}
												type="text"
												placeholder="Email"
												className="form-control bg-transparent"
												value={email}
												onChange={(e) => {setEmail(e.target.value); setErrorEmail("");}}
											/>
											{errorEmail && <p className="text-danger">{errorEmail}</p>}
										</div>
										<div class="fv-row mb-3">
											<input
											ref={passwordRef}
												type="password"
												placeholder="Password"
												className="form-control bg-transparent"
												value={password}
												onChange={(e) => {setPassword(e.target.value); setErrorPassword("");}}
											/>
											{errorPassword && <p className="text-danger">{errorPassword}</p>}
										</div>
										<div class="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
											<div></div>
											<a href="/forgot-password" class="link-primary">Forgot Password ?</a>

										</div>
										<div class="d-grid mb-10">


											<button type="submit" className="btn btn-primary">
												<span className="indicator-label">Sign In</span>
												{loading && (
													<p class="text-center load"><span class="loader"></span></p>
												)}
											</button>
										</div>
										{/*<div class="text-gray-500 text-center fw-semibold fs-6">Not a Member yet?
											 <a href="/registration" class="link-primary">Sign up</a></div> */}

									</form>
								</div>



								<div class="d-flex fw-semibold text-primary justify-content-between flex-wrap mt-3">

									<a href="/privacy-policy" target="_blank">Privacy Policy</a>
									<a href="/terms-of-service" target="_blank">Terms of Service</a>
									<a href="/payment-security" target="_blank">Payment Security</a>
								</div>
								<div className="mt-5">
									<a
										href="https://securwires.com/cert/index.php?id=Berry@1"
										target="_blank"
										rel="noopener noreferrer"
									>
										<img
											style={{ width: "110px" }}
											src="https://securwires.com/cert/SecurWiresWebSealPay.png"
											alt="SecurWires Web Seal"
										/>
									</a>
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</>

	);
}
export default Login;
